module.exports = {"Operate18":{"daobanList":[{"title":"1:是否允许劳务派遣经营许可（新设）","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、中华人民共和国入出境通行证申请表","state":"必要"},{"name":"2、居民身份证","state":"必要"},{"name":"3、境外人员临时住宿登记表","state":"必要"},{"name":"4、回乡证、港澳居民身份证等","state":"必要"},{"name":"5、符合规定的相片及相片回执","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-18.json
// module id = 1275
// module chunks = 0